import React from 'react';
import {Link} from 'react-router-dom';
import '../assets/css/task-status.css';

const TaskStatus = (props)=> {
	return (
		<span className={`task-status d-flex ${props.color ? props.color : ''}`}>
			<span><img src={props.icon ? props.icon : ''} className="mr-1" style={{ marginBottom: "5px"}}/></span>
			<span>{props.text ? props.text : ''}</span>
		</span>
	);
}

export default TaskStatus;